module.exports = __webpack_public_path__ + "kp.svg?33d60e625bbf5f0d6849c59a294a363f";